import { Box, Chip, Tab, Tabs } from '@mui/material';
import { Container } from 'Components/Container';
import { Column } from 'Components/Grid';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { ColumnEdit, LinkEdit, RowExhibition } from './styles';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { getCompanyById } from 'services/company-service';
import { PageLoaderShow } from 'Components/PageLoader/Show';
import { TabPanel } from 'Components/TabPanel';
import { useTranslation } from 'react-i18next';

export const CompaniesShow = () => {
  const { t } = useTranslation(['company']);
  const navigate = useNavigate();
  const { id } = useParams();
  const [tabPosition, setTabPosition] = useState(0);
  const {
    isLoading,
    error,
    data: company,
  } = useQuery('getCompanyById', async () => {
    const dataCompany = await getCompanyById(id);
    return dataCompany.status === 200 ? dataCompany.data : null;
  });

  const onClickEdit = () => {
    navigate('/companies/edit/' + id);
  };

  return (
    <>
      {!isLoading && !error && (
        <Container
          title={`${company?.name}`}
          breadcrumb={`${t('company:companies.show.breadcrumb')} / ${company?.name}`}
          linkPage="/companies"
        >
          <Box sx={{ width: '100%' }} className="container">
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                value={tabPosition}
                onChange={(data, newValue) => setTabPosition(newValue)}
                aria-label="basic tabs example"
              >
                <Tab
                  label={t('company:companies.show.tabDetails')}
                  id="tab-details"
                  aria-controls="tabpanel-details"
                  style={{ marginLeft: 0, marginTop: 0, width: 'fit-content' }}
                />
                <Tab
                  label={t('company:companies.show.tabManagers')}
                  id="tab-managers"
                  aria-controls="tabpanel-managers"
                  style={{ marginLeft: 0, marginTop: 0, width: 'fit-content' }}
                />
              </Tabs>
            </Box>
            <TabPanel value={tabPosition} index={0} id="tabpanel-details" ariaLabel="tab-details">
              <RowExhibition>
                <Column xs={3}>{t('company:companies.show.name')}</Column>
                <Column>{company.name}</Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: '#0039C5' }} />
                    {t('company:companies.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
              <RowExhibition>
                <Column xs={3}>{t('company:companies.show.corporateName')}</Column>
                <Column>{company?.corporateName}</Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: '#0039C5' }} />
                    {t('company:companies.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
              <RowExhibition>
                <Column xs={3}>{t('company:companies.show.slug')}</Column>
                <Column>{company.slug}</Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: '#0039C5' }} />
                    {t('company:companies.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
              <RowExhibition>
                <Column xs={3}>{t('company:companies.show.cnpj')}</Column>
                <Column>{company.cnpj}</Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: '#0039C5' }} />
                    {t('company:companies.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
              <RowExhibition>
                <Column xs={3}>{t('company:companies.show.size')}</Column>
                <Column>{company?.size}</Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: '#0039C5' }} />
                    {t('company:companies.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
              <RowExhibition>
                <Column xs={3}>{t('company:companies.show.income')}</Column>
                <Column>{company.income}</Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: '#0039C5' }} />
                    {t('company:companies.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
              <RowExhibition>
                <Column xs={3}>{t('company:companies.show.industry')}</Column>
                <Column>{company.industry}</Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: '#0039C5' }} />
                    {t('company:companies.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
              <RowExhibition>
                <Column xs={3}>{t('company:companies.show.domains')}</Column>
                <Column>
                  {company.domains?.map(domain => (
                    <Chip
                      key={`company-domain-${domain}`}
                      label={domain}
                      variant="outlined"
                      color="primary"
                      sx={{
                        width: 'fit-content',
                        marginInlineEnd: '6px',
                      }}
                    />
                  ))}
                </Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: '#0039C5' }} />
                    {t('company:companies.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
              <RowExhibition>
                <Column xs={3}>{t('company:companies.show.active')}</Column>
                <Column>{company.active ? t('company:companies.show.yes') : t('company:companies.show.no')}</Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: '#0039C5' }} />
                    {t('company:companies.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
              <RowExhibition>
                <Column xs={3}>{t('company:companies.show.partner')}</Column>
                <Column>{company.partner ? t('company:companies.show.yes') : t('company:companies.show.no')}</Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: '#0039C5' }} />
                    {t('company:companies.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
              <RowExhibition>
                <Column xs={3}>{t('company:companies.show.signedPlan')}</Column>
                <Column>{company?.signedPlan}</Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: '#0039C5' }} />
                    {t('company:companies.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
              <RowExhibition>
                <Column xs={3}>{t('company:companies.show.description')}</Column>
                <Column>{company.description}</Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: '#0039C5' }} />
                    {t('company:companies.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
            </TabPanel>
            <TabPanel value={tabPosition} index={1} id="tabpanel-managers" ariaLabel="tab-managers">
              <RowExhibition>
                <Column>
                  {company.managers?.map(manager => (
                    <Chip
                      key={`company-chip-${manager._id}`}
                      label={manager.name}
                      variant="outlined"
                      color="primary"
                      sx={{
                        width: 'fit-content',
                      }}
                    />
                  ))}
                </Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: '#0039C5' }} />
                    {t('company:companies.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
            </TabPanel>
          </Box>
        </Container>
      )}
      {isLoading && <PageLoaderShow />}
      {error && <div>{t('company:companies.show.error')}</div>}
    </>
  );
};
